import React from "react";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";

const BreadcrumbsContainer = styled.div`
  display: inline-block;
  font-family: system-ui;
  font-weight: 500;
  overflow: hidden;
  border-radius: 5px;
  width: max-content;
`;

const BreadcrumbLink = styled.a`
  text-decoration: none;
  outline: none;
  display: block;
  float: left;
  font-size: 12px;
  line-height: 30px;
  color: #000;

  background: #e9d7cf;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: -15px;
    width: 30px;
    height: 30px;
    transform: scale(0.707) rotate(45deg);
    z-index: 1;
    background: #e9d7cf;
    box-shadow: 2px -2px 0 0px #fff, 3px -3px 0 3px #fff;
    border-radius: 0 5px 0 50px;
  }

  &:last-child:after {
    content: none;
  }
  &.active {
    padding: 0 10px 0 35px;
  }
  &:hover,
  &.active {
    background: rgb(190, 137, 118);
    color: #fff;
  }
  &:first-child {
    margin-left: -20px;
  }

  &.navigate-cursor {
    cursor: pointer;
  }

  &:hover:after,
  &.active:after {
    background: rgb(190, 137, 118);
  }

  a {
    color: inherit;
    text-decoration: none;
    padding: 0 0px 0 35px;
    margin: 0px 10px 0px 0px;
    width: calc(100% - 22px);
    position: relative;
    display: block;
    z-index: 99;
    &:hover {
      color: #fff;
    }
  }
`;

const Breadcrumbs = (props) => {
  const { breadCrumbData } = props;
  const navigate = useNavigate();
  return (
    <BreadcrumbsContainer>
      {breadCrumbData?.map((item, index) => (
        <BreadcrumbLink
          key={index}
          className={
            item.active ? item.active : item.navigate ? "navigate-cursor" : ""
          }
        >
          {item.href || item.navigate ? (
            <Link to={item.navigate !== undefined ? item.navigate : item.href}>
              {item.title}
            </Link>
          ) : (
            <span>{item.title}</span>
          )}
        </BreadcrumbLink>
      ))}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
